export default __webpack_public_path__ + "static/media/instagram (1).dd7badfa.svg";